import {
  faMagnifyingGlass,
  faPhone,
  faUser,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { KeyboardEvent, useState } from "react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { InputGroup, InputGroupText } from "../ui/input-group";
import { Label } from "../ui/label";
import { FormField } from "../ui/form-field";

export interface CustomerSearchProps {
  onChange: (phone: string, name: string) => void;
}

const CustomerSearch = (props: CustomerSearchProps) => {
  const emptyFields = { phone: "", name: "" };

  const [searchFields, setSearchFields] = useState(emptyFields);

  const search = () => {
    props.onChange(searchFields.phone, searchFields.name);
  };

  const clear = () => {
    setSearchFields(emptyFields);
    props.onChange("", "");
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      search();
    }
  };

  return (
    <Card>
      <CardContent className="p-4">
        <div className="grid gap-4 sm:grid-cols-2">
          <FormField>
            <Label htmlFor="search-name">Nombre</Label>
            <InputGroup>
              <InputGroupText className="rounded-r-none border-r-0">
                <FontAwesomeIcon icon={faUser} />
              </InputGroupText>
              <Input
                id="search-name"
                type="text"
                placeholder="Nombre del Cliente"
                className="rounded-l-none"
                value={searchFields.name}
                onKeyDown={handleKeyDown}
                onChange={(event) =>
                  setSearchFields({ ...searchFields, name: event.target.value })
                }
              />
            </InputGroup>
          </FormField>
          <FormField>
            <Label htmlFor="search-phone">Teléfono</Label>
            <InputGroup>
              <InputGroupText className="rounded-r-none border-r-0">
                <FontAwesomeIcon icon={faPhone} />
              </InputGroupText>
              <Input
                id="search-phone"
                type="number"
                placeholder="##########"
                maxLength={10}
                className="rounded-l-none"
                value={searchFields.phone}
                onKeyDown={handleKeyDown}
                onChange={(event) =>
                  setSearchFields({ ...searchFields, phone: event.target.value })
                }
              />
            </InputGroup>
          </FormField>
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <Button variant="secondary" onClick={() => clear()}>
            <FontAwesomeIcon icon={faXmark} />
            Limpiar
          </Button>
          <Button onClick={() => search()}>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
            Buscar
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default CustomerSearch;
